import React from "react";
import PropTypes from "prop-types";
import Select from 'react-select'
import ToggleOnOff from "./ToggleOnOff"
import PlaceholderValueContainer from "./PlaceholderValueContainer"
import DefaultTooltip from "../tooltips/DefaultTooltip"
import { updateUrlParams, urlParamsToObject } from "../../utility/UrlUtils"

class SuperFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterValues: props.defaultValues ? props.defaultValues : {},
      locked: false,
    }
    this.getSelectedFilters = this.getSelectedFilters.bind(this);
    this.setFilterValue = this.setFilterValue.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.setMultiSelectFilterValue = this.setMultiSelectFilterValue.bind(this);
    this.toggleLock = this.toggleLock.bind(this);
    this.searchRef = React.createRef();
  }

  handleKeyDown = (e) => {
    console.log(e, "Keydown")
    const isFindShortcut = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "f";

    if (isFindShortcut) {
      console.log("found")
      e.preventDefault();

      this.searchRef.current?.focus();
      this.searchRef.current?.select(); // Optional
    }
  };

  componentDidMount() {
    const { onChange } = this.props;
    this.manageLockOnMount();
    if(onChange) {
      onChange(this.getSelectedFilters());
    }
    window.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKeyDown);
  }



  /******
  * Filter Schema (object)
  * id: Unique ID
  * type: onoff, select,
  * Options (array, object): {id, label, filterFunction, filterType(optional)}
  * outerClassName(optional)
  * innerClassName(optional)
  * placeholder(optional)
  *****/
  renderFilters() {
    const { filters } = this.props;
    return filters.map((f,index)=>
      <div
        key={`super-filter-${index}-${f.id}`}
        className={
          `${f.outerClassName} ${this.isFilterSelected(f.id) ? "cnt-super-filter-active" : "cnt-super-filter-inactive"}`
        }
        style={f.outerStyle||{}}
      >
        {this.renderFilter(f,index)}
      </div>
    )
  }

  getSelectedFilters() {
    const {filters} = this.props;
    const {filterValues} = this.state;
    const selectedFilterKeys = Object.keys(filterValues).filter(x=>filterValues[x]);
    return filters.filter(x=> selectedFilterKeys.indexOf(x.id) != -1).map(f1=> {
      const option = f1.options.find(f2=>f2.id == filterValues[f1.id])
      return {
        filterType: option ? option.filterType : null,
        filterID: f1.id,
        filterOptionID: option ? option.id : null,
        filterFunction: option ? option.filterFunction : null,
        filterValue: filterValues[f1.id]
      }
    })
  }

  isFilterSelected(id) {
    const {filterValues} = this.state;
    const selectedFilterKeys = Object.keys(filterValues).filter(x=>filterValues[x]);
    return selectedFilterKeys.findIndex(x=> x == id) != -1;
  }

  setMultiSelectFilterValue(filterObject,value) {

    const  { defaultValues } = this.props;
    if((value||[]).length > 0){
      const recentlyAddedValue=value[value.length - 1]
      const recentlyAddedOption = filterObject.options.find(x=>x.id == recentlyAddedValue.value);
      if(recentlyAddedOption && recentlyAddedOption['solo']) {
        value = [recentlyAddedValue]
      }else {
        value = value.filter(x=> {
          const xobject = filterObject.options.find(y=>y.id == x.value);
          return !xobject.solo
        })
      }
    }else {
      value = [{value: null}]
    }
    this.setFilterValue(filterObject.id, (value||[]).map(x=>x.value));
  }

  setFilterValue(name,value) {
    this.setState((state, props) =>{
      let { filterValues } = state;
      const { onChange } = props;
      if(value == null) {
          if(this.isUrlLocked()){removeUrlParam(name)}
        delete filterValues[name];
      }else {
        filterValues[name] = value;
      }
      if(onChange) {
        onChange(this.getSelectedFilters());
      }
      if(this.isTableLocked()){this.updateLockedFilterValues()}
      if(this.isUrlLocked()){this.updateUrlLock()}

      return {filterValues}
    })

  }

  renderFilter(filterObject,index) {
    const {filterValues, disableLabel} = this.state;
    const value = filterValues[filterObject.id];
    switch(filterObject['type']) {
      case "onoff":
        return (
          <div className={filterObject.innerClassName}>
            <div style={{color: "#7C7C7C", display:"flex", alignItems:"center"}}>
              <ToggleOnOff
                value={value=="true"}
                label={filterObject.label}
                onClick={
                  ()=>this.setFilterValue(filterObject.id, value == "true" ? "false" : "true")
                }/>
            </div>
          </div>
        )
      case "select":
        return (
          <Select
            isClearable={false}
            options={
              filterObject.options.map(x=> {
                return {
                  value: x.id,
                  label: x.label
                }
              })
            }
            classNamePrefix='cnt-default-layout-super-filter-select'
            placeholder={filterObject.placeholder}
            onChange={(e)=>this.setFilterValue(filterObject.id, e.value)}
            value={
              this.getSelectFilterValue(filterObject, value)
            }
          />
      );
      case "multiselect":
      return (
        <>
        <div>
          {disableLabel ? filterObject.name: ""}
        </div>
        <Select
          styles={{ menu: base => ({ ...base, zIndex: 5 }) }}
          className="select-outlined"
          classNamePrefix="select-outlined"
          options={
            filterObject.options.map(x=> {
              return {
                value: x.id,
                label: x.label
              }
            })
          }
          onChange={(value) =>
            this.setMultiSelectFilterValue(filterObject, value)
          }
          value ={(value||[]).map(x=>this.getSelectFilterValue(filterObject,x))}
          placeholder={filterObject.placeholder}
          components={{ValueContainer: PlaceholderValueContainer}}
          isMulti
          isClearable={false}
        />
        </>
      );
      case "search":
        return (
          <>
          <div>
            {disableLabel ? filterObject.label: ""}
          </div>
          <input
            id={`super-filter-search`}
            style={{height: "38px"}}
            ref={this.searchRef}
            className='form-control'
            placeholder={filterObject.placeholder}
            onChange={(e)=>this.setFilterValue(filterObject.id, e.target.value)}
            value={
              this.getSelectFilterValue(filterObject, value)
            }
          />
          </>
        );
      default:
        return (<div className="cnt-error"> Must Select a type for a filter.</div>)
    }
  }

  getSelectFilterValue(filter,value) {
    if(value) {
      const foundValue = filter.options.find(x=>x.id == value)
      if(foundValue) {
        return {
          label: foundValue.label,
          value: foundValue.id
        }
      }
    }
    return null
  }

  resetFilters() {
    const { onChange } = this.props;
    if(onChange) {
      onChange([]);
    }
    if(this.isTableLocked()){this.updateLockedFilterValues()}
    if(this.isUrlLocked()){this.updateUrlLock()}
    this.setState({
      filterValues: {}
    })
  }

  renderMultiSelectValues() {
    const { filters } = this.props;
    const {filterValues} = this.state;
    const   values = filters.map((filter,filterIndex) => {
      const value = filterValues[filter.id];
      if(filter.type=='multiselect' && value){
        return value.filter(x=>x).map(x=>(
          <div key={`cms-super-filter-tag-${filter.id}-${x}`} onClick={()=>this.setMultiSelectFilterValue(filter, value.filter(y=>y != x).map(y=>{return{value: y}}))} className="cms-super-filter-value-tag">
            {(filter.options.find(y=>y.id == x)||{label: x})['label']}
            <span className="cms-super-filter-value-close-button"> x </span>
          </div>
        ))
      }
      return [];
    }).flat()
    return (
      <>
      <div className="cms-super-filter-value-tags">
        {values}
      </div>
      <div>
        {values && values.length > 0 ? (<><br/><br/></>) : ""}
      </div>
      </>
    )
  }

  /***************
  * Lock Code
  * Function: Makes changes to super filter retain after reload
  * Should only function when lockable prop is active
  * Requires superfilter id when more than one exists per site
  *****************/

  renderLock() {
    const { lockable } = this.props;
    const { locked } = this.state;
    if(lockable)
    return (
      <>
      <DefaultTooltip title={locked ? "Unlock filter selections" : "Lock filter selections"} tooltipId={`cms-super-filter-lock`}>
        <div
          onClick={this.toggleLock}
          className={`cms-super-filter-lock ${locked ? "locked" : "unlocked"}`}
          data-for="cms-super-filter-lock"
          data-tip
        >
          <img src={`/images/icons/${locked ? "lock.png" : "unlock.png"}`} />
        </div>
      </DefaultTooltip>
  
      </>
    )
  }

  toggleLock() {
    const { locked } = this.state;
    this.updateIsLocked(!locked);
    this.updateLockedFilterValues();
    this.setState({
      locked: !locked
    })
  }

  getLockSuperFilterId() {
    const { id } = this.props;
    return `${id}-superfilter-lock`
  }

  getLockSuperFilterValueId() {
    return this.getLockSuperFilterId()+"-values"
  }

  isTableLocked() {
    const { lockable } = this.props;
    const { locked } = this.state;
    return locked && lockable;
  }

  isUrlLocked() {
    const { urlLock } = this.props;
    return urlLock;
  }

  //Updates the stored value value of the filters as JSON
  //Keep functions seperate, to allow discrete implementation
  //Local Storage Max capacity 5mb

  updateIsLocked(value) {
    localStorage.setItem(
      this.getLockSuperFilterId(),
      value
    );
  }

  updateUrlLock() {
    const { urlLock } = this.props;
    const { filterValues } = this.state;
    updateUrlParams(filterValues);
  }

  updateLockedFilterValues() {
    const { urlLock } = this.props;
    const { filterValues } = this.state;
    localStorage.setItem(
      this.getLockSuperFilterValueId(),
      JSON.stringify(filterValues)
    );
  }

  getLockedFilterValues() {
    const { lockable, defaultValues } = this.props;
    if(lockable) {
      const rememberedValue = localStorage.getItem(this.getLockSuperFilterValueId());
      //Grab cookie with values in it
      //Transform into object and store in state
      //Try catch to prevent malformed json crashing app.
      try {
        if(rememberedValue) {
          let to_return = JSON.parse(rememberedValue);
          //Remove search from lockable params, per request.
          //Search doesnt render correctly when not removed, fix before undoing.
          to_return['search']=""
          return to_return;
        }else {
          console.log("[SuperFilter][Lock] No locked value found")
        }
      } catch(e) {
        console.log("[Error][SuperFilter][Lock] Unable to fetch super filter lock")
        console.log(e);
      }
    }
    return defaultValues || {}
  }

  getUrlLockedFilterValues() {
    const { urlLock, defaultValues, filters} = this.props;
    if(urlLock) {
      try {
          let searchObject = urlParamsToObject()
          Object.keys(searchObject).map(key=> {
            const filter = filters.find(y=>y.id == key)
            if(key && filter) {
              if(filter['type']=='multiselect') {
                searchObject[key]=((searchObject[key]||"").split(","))
              }
            }
            if (searchObject[key] === null || searchObject[key]===undefined || searchObject[key]=='') {
              delete searchObject[key];
            }
          })
          return searchObject;
      } catch(e) {
        console.log("[Error][SuperFilter][UrlLock] Unable to fetch super filter lock")
        console.log(e);
      }
    }
    return defaultValues || {}
  }

  manageLockOnMount() {
    const { lockable, urlLock } = this.props;
    const locked = localStorage.getItem(
      this.getLockSuperFilterId()
    ) == "true";
    if(lockable) {
      //Check if table was locked
      //LocalStorage only stores string representations
      if(locked) {
        let values = this.getLockedFilterValues();
        //First render happening, set state wont trigger state change in timeout
        //Manually overriding state works, but isn't a great solution
        this.state.filterValues = values;
        this.setState({
          locked,
          filterValues: values
        })
      }
    }
    if(urlLock && (!lockable || !locked)) {
      let values = this.getUrlLockedFilterValues()
      this.state.filterValues = values;
      this.setState({
        filterValue: this.getUrlLockedFilterValues()
      })
    }
  }

  renderPostFilter() {
    const { postFilter } = this.props;
    if(postFilter) {
      return postFilter
    }
    return null
  }

  render() {
    const { value } = this.props;
    return (
      <div className="cnt-default-layout-super-filter">
        {this.renderFilters()}
        {this.renderLock()}
        {this.renderPostFilter()}
        {this.renderMultiSelectValues()}

      </div>
    );
  }
}

export default SuperFilter;
